module.exports = __webpack_public_path__ + "img/company_namelist.a3e3d1a7.png";